// If we're on the page 'thank-you-for-rating" and Gravity forms is ready and the form Gravity Form with the class .nps-survey-form exists, and the url has the paramter mg_source=from_email, then wait 500ms and submit the form
document.addEventListener("DOMContentLoaded", function () {
  console.log("DOMContentLoaded");
  const mgWindowOptions = window.location;

  if (
    mgWindowOptions.pathname === "/thank-you-for-rating/" &&
    document.querySelector(".nps-survey-form") &&
    mgWindowOptions.search.includes("mg_source=from_email")
  ) {
    document
      .querySelector(".nps-survey-form input[type='submit']")
      .classList.add("btn--grab-attention");
  }
});
